import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "../../pages/academy/academy.module.css";
import {fontType} from "../../constants/font";

const Loopingpromo = () => {
  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "hidden",
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#1b144a",
        display: "flex",
      }}
    >
      <Box
        sx={{
          height: "55px",
          backgroundColor: "#1b144a",
          width: "1440px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflowX: "hidden",
          whiteSpace: "nowrap",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Typography
          className={styles.slide}
          sx={{
            fontFamily: fontType.regular,
            fontSize: 22,
            color: "white",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
            Financujte V
          <span
            style={{
              color: "#3fcaea",
              fontFamily: fontType.bold,
            }}
          >
            AAŠ
          </span>
            e školenie{" "}cez{" "}
          <span
            style={{
              color: "#3fcaea",
              fontFamily: fontType.bold,
            }}
          >
              programy Úradu práce
          </span>
          <span style={{ marginRight: "55px" }} />
            Financujte V
          <span
            style={{
              color: "#3fcaea",
              fontFamily: fontType.bold,
            }}
          >
            AAŠ
          </span>
            e školenie{" "}cez{" "}
          <span
            style={{
              color: "#3fcaea",
              fontFamily: fontType.bold,
            }}
          >
            programy Úradu práce
          </span>
            <span style={{ marginRight: "55px" }} />
            Financujte V
            <span
                style={{
                    color: "#3fcaea",
                    fontFamily: fontType.bold,
                }}
            >
            AAŠ
          </span>
            e školenie{" "}cez{" "}
            <span
                style={{
                    color: "#3fcaea",
                    fontFamily: fontType.bold,
                }}
            >
            programy Úradu práce
          </span>
            <span style={{ marginRight: "55px" }} />
            Financujte V
            <span
                style={{
                    color: "#3fcaea",
                    fontFamily: fontType.bold,
                }}
            >
            AAŠ
          </span>
            e školenie{" "}cez{" "}
            <span
                style={{
                    color: "#3fcaea",
                    fontFamily: fontType.bold,
                }}
            >
            programy Úradu práce
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default Loopingpromo;
